export default __webpack_public_path__ + "static/media/login-bg-left.931d1943.png";